export default __webpack_public_path__ + "static/media/mobile.e99e9cb2.png";